import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { QueryBuilder } from '@/core/uql';
import cloneDeep from 'lodash/cloneDeep';

interface ShiftAtomCoockPlanState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    prevDocumentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedPlansList: any[];
    prevPlansList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
}

const state: ShiftAtomCoockPlanState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    prevDocumentId: null,
    clientId: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedPlansList: [],
    prevPlansList: [],

    targetForDelete: [],
    // products: [],
    remains: []
};

const initState: any = cloneDeep(state);

const PL_RELAED_PRODUCTS_LIST = 'PL_RELAED_PRODUCTS_LIST';
const PREV_SHIFT_LIST = 'PREV_SHIFT_LIST';
const WASHIG_SHIFT_LIST = 'WASHIG_SHIFT_LIST';

function getBasketItem(state: ShiftAtomCoockPlanState, saved: any, relTimeOfDay: string) {
  if (saved) {
    return {
      id: saved.id,
      full_id: saved.full_id,
      number: saved.number,
      product_name: saved.product_name,
      line_name: saved.line_name,
      quantity: saved.quantity,
      deleted_at: saved.deleted_at,
      base_id: saved.base_id,
      items: saved.items,
      type: saved.type,
      wash_type: saved.wash_type,
      detergent_name: saved.detergent_name,
      detergent_volume: saved.detergent_volume,
      water_volume: saved.water_volume,
      created_at: saved.created_at,
      mix_name: saved.mix_name,
    };
  } else {
    const letter = relTimeOfDay ? relTimeOfDay[0] : ''
    return {
      id: Math.random(),
      number: null,
      product_name: null,
      line_name: null,
      quantity: null,
      shift_date: null,
      deleted_at: null,
      filter_base_id: null,
      items: [],
      type: null,
      wash_type: null,
      detergent_name: null,
      detergent_volume: null,
      water_volume: null,
      created_at: null,
      mix_name: null,
    }
  }

}

export const actions: ActionTree<ShiftAtomCoockPlanState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains, realEndTime, relTimeOfDay }) {
        const vm = (this as any)._vm;
        console.log('relTimeOfDay', relTimeOfDay)

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          vm.$db([
            vm.$q(PL_RELAED_PRODUCTS_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sacp.id',
                  created_at: 'sfpa.created_at',
                  full_id: 'sfpa.id',
                  number: 'sfpa.number',
                  product_name: 'pp.name',
                  line_name: 'vl.name',
                  base_id: 'pp.base_id',
                  quantity: {$sum: 'sacpi.quantity'},
                  deleted_at:'sacp.deleted_at',
                  items: {
                    $array_agg: {
                        $obj: {
                          id: 'sacpi.id',
                          number: 'spv.number',
                          shift_date: 's.shift_date',
                          shift_times_of_day: 's.times_of_day',
                          base_name: 'vb.name',
                          base_product_date: 'sacpi.base_product_date',
                          quantity: 'sacpi.quantity',
                          weight: 'sacpi.weight',
                          deleted_at:'sacpi.deleted_at',
                          container_name: 'vc.name',
                          comment: 'sfv.comment',
                          mark_no_incident: 'vbm.no_incident',
                          mark_water_state: 'vbm.water_state',
                          mark_no_fat: 'vbm.no_fat',
                          mark_normal_acidity: 'vbm.normal_acidity',
                          mix_name: 'vsm.plan_name',
                        }
                    }
                  }
                },
                from: 's:shift_full_plan_atom',
                from_as: 'sfpa',
                joins: [
                  {
                    join: 's:shift_atom_coock_plan',
                    type: 'left',
                    as:   'sacp',
                    on: {
                      $eq: ['sacp.id', 'sfpa.plan_id']
                    }
                  },
                  {
                    join: 's:produced_products',
                    type: 'left',
                    as:   'pp',
                    on: {
                      $eq: ['pp.id', 'sacp.product_id']
                    }
                  },
                  {
                    join: 's:shift_atom_coock_plan_items',
                    type: 'left',
                    as:   'sacpi',
                    on: {
                      $eq: ['sacpi.coock_plan_id', 'sacp.id']
                    }
                  },
                  {
                    join: 's:shift_plan_vdp',
                    type: 'left',
                    as:   'spv',
                    on: {
                      $eq: ['sacpi.vdp_plan_id', 'spv.id']
                    }
                  },
                  {
                    join: 's:view_shift_mixes',
                    type: 'left',
                    as:   'vsm',
                    on: {
                      $eq: ['spv.id', 'vsm.id']
                    }
                  },
                  {
                    join: 's:shifts',
                    type: 'left',
                    as:   's',
                    on: {
                      $eq: ['spv.shift_id', 's.id']
                    }
                  },
                  {
                    join: 's:voc_bases',
                    type: 'left',
                    as:   'vb',
                    on: {
                      $eq: ['sacpi.base_id', 'vb.id']
                    }
                  },
                  {
                    join: 's:warehouse_internal_remains',
                    type: 'left',
                    as:   'wir',
                    on: {
                      $eq: ['sacpi.warehouse_internal_remains_id', 'wir.id']
                    }
                  },
                  {
                    join: 's:shift_fact_vdp',
                    type: 'left',
                    as:   'sfv',
                    on: {
                      $eq: ['sfv.shift_plan_id', 'spv.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vc',
                    on: {
                      $eq: ['vc.id', 'sfv.container_id']
                    }
                  },
                  {
                    join: 's:view_base_mark',
                    type: 'left',
                    as:   'vbm',
                    on: {
                      $eq: ['vbm.id', 'sfv.id']
                    }
                  },
                  {
                    join: 's:voc_lines',
                    type: 'left',
                    as:   'vl',
                    on: {
                      $eq: ['vl.id', 'sacp.line_id']
                    }
                  },
                ],
                page_size: 50,
                order: [
                  {$asc: ['sacp.number']}
                ],
                where: {
                  $eq: [`sacp.shift_id`, {$: documentId}]
                },
                groups: [
                  'sacp.id', 'sfpa.id', 'sfpa.number', 'pp.name', 'pp.base_id', 'vl.name', 'vsm.plan_name'
                ]
              }),
              vm.$q(WASHIG_SHIFT_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sfpa.id',
                  full_id: 'sfpa.id',
                  number: 'sfpa.number',
                  product_name: 'vv.name',
                  wash_type: 'vwt.name',
                  water_volume: 'vvw.water_volume',
                  detergent_volume: 'vvw.detergent_volume',
                  detergent_concentration: 'vvw.detergent_concentration',
                  detergent_name: 'vd.name',
                },
                from: 's:shift_full_plan_atom',
                from_as: 'sfpa',
                joins: [
                  {
                    join: 's:shift_plan_washing',
                    as:   'spw',
                    on: {
                      $eq: ['spw.id', 'sfpa.wash_id']
                    }
                  },
                  {
                    join: 's:voc_volumes',
                    as:   'vv',
                    on: {
                      $eq: ['vv.id', 'spw.equipment_id']
                    }
                  },
                  {
                    join: 's:voc_volumes_washings',
                    as:   'vvw',
                    on: {
                      $eq: ['vvw.id', 'spw.washing_id']
                    }
                  },
                  {
                    join: 's:washings',
                    as:   'w',
                    on: {
                      $eq: ['w.id', 'vvw.washing_id']
                    }
                  },
                  {
                    join: 's:voc_washing_types',
                    as:   'vwt',
                    on: {
                      $eq: ['vwt.id', 'w.type_id']
                    }
                  },
                  {
                    join: 's:voc_detergents',
                    as:   'vd',
                    on: {
                      $eq: ['vd.id', 'w.detergent_id']
                    }
                  },
                ],
                where: {
                  $eq: [`sfpa.shift_id`, {$: documentId}]
                }
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(PL_RELAED_PRODUCTS_LIST);
            const opWashResult = result.getOperation(WASHIG_SHIFT_LIST);
            if (!opRelResult.hasError()) {
              state.relatedPlansList = opRelResult.getContent().documents.map((doc: any) => {
                doc.type = 'prod'
                return getBasketItem(state, doc, relTimeOfDay)
              }).filter((item: any) => {
                return !realEndTime || item.fact_id
              });
              state.relatedPlansList.push(...opWashResult.getContent().documents.map((doc: any) => {
                doc.type = 'wash'
                return getBasketItem(state, doc, relTimeOfDay)
              }))
            }
            commit('LOADED_SUCCESS');

            resolve(null);
          });
        })
    },


    addItem({ state }, relTimeOfDay) {
      console.log('relTimeOfDay', relTimeOfDay)
      state.relatedPlansList.push(
        getBasketItem(state, null, relTimeOfDay)
      )
    },

    removeItem({ state }, index: number) {
        if (state.relatedPlansList[index].id) {
            state.targetForDelete.push(state.relatedPlansList[index].id)
        }

        state.relatedPlansList.splice(index, 1);
    },

    changeFormValue({ state, commit }, { index, field, newValue}) {
      commit('SET_FROM_DATA', {index, field, newValue})
    },

    saveForm({ state, dispatch }, {realEndTime}) {
      const vm = (this as any)._vm;
      const allowedFields = ['id', 'base_id', 'number', 'attachments', 'starter_type_id'];

      return new Promise((resolve, reject) => {
        const normalizedItemsData = state.relatedPlansList.map((item, index) => {
          console.log('n => ', item);
          const cleanDocuemnt: any = Object.keys(item)
          .filter((key: string) => allowedFields.includes(key))
          .reduce((obj: any, key: string) => {
              console.log('key => ', key, obj);
              if (key == 'id') {
                console.log('d1 => ', item[key]);
                item[key] = (typeof(item[key]) == 'string') ? item[key] : null;
                console.log('d2 => ', item[key]);
              }
              obj[key] = item[key];
              return obj;
            }, {});

          console.log('d => ', cleanDocuemnt);
          return cleanDocuemnt;
        });

        const queries = [
          vm.$q(`SAVE_DEAL_BASKET`)
            .update(state.documentId, {})
            .createManyRelation('shift_plan_vdp', 'shift_id', (createRelated: any) => {
              return normalizedItemsData.filter((item: any) => !item.id || (typeof(item.id) !== 'string')).map((item, index) => createRelated(item));
            })
            .updateManyRelation('shift_plan_vdp', 'shift_id', (updateRelated: any) => {
              return normalizedItemsData.filter((item: any) => (typeof(item.id) == 'string')).map((item, index) => updateRelated(item))
            })
        ]

        vm.$db(queries)
          .then((result: ServerResult) => {
            const totalSaveRes = !result.getOperation(`SAVE_DEAL_BASKET`).hasError();
            if (totalSaveRes) {
              state.targetForDelete = [];

              dispatch('loadData', { documentId: state.documentId, realEndTime})
                .then(() => {
                  resolve();
                })
            } else {
              reject();
            }
          });
      })
    },
   
    reorderPlan({ state, dispatch }, {item1, item2}) {
      const vm = (this as any)._vm;

      vm.$db([
        (vm.$q('REORDER_PLAN_1') as QueryBuilder)
          .update(item1.full_id, { number: item2.number }),
        (vm.$q('REORDER_PLAN_2') as QueryBuilder)
          .update(item2.full_id, { number: item1.number })
      ])
      .then(() => {
          dispatch('loadData', { documentId: state.documentId, silence: true})
      })
    },

    deleteDocument({ state, dispatch }, row) {
      const vm = (this as any)._vm;

      vm.$db([
          (vm.$q('DELETE_DOCUMENT') as QueryBuilder)
            .update(row.id, { deleted_at: moment().utc().local().format() })
      ])
      .then(() => {
          dispatch('loadData', { documentId: state.documentId, silence: true})
      })
    },

    restoreDocument({ state, dispatch }, row) {
      const vm = (this as any)._vm;

      vm.$db([
          (vm.$q('DELETE_DOCUMENT') as QueryBuilder)
            .update(row.id, { deleted_at: null })
      ])
      .then(() => {
          dispatch('loadData', { documentId: state.documentId, silence: true})
      })
    },
    
    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=10>ID</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Номер</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Тара</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Продукт</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Количество</td>
</tr>
{{#plan.documents}}
  <tr height="auto">
    <td wrap border base >{{id}}</td>
    <td wrap border base >{{number}}</td>
    <td wrap border base >{{container_name}}</td>
    <td wrap border base >{{product_name}}</td>
    <td wrap border base round align=center>{{quantity}}</td>
  </tr>
{{/plan.documents}}
</table>
                `,
                queries: {
                  plan: {
                    columns: {
                      id: 'sa.id',
                      number: 'sa.number',
                      container_name: 'vc.name',
                      product_name: 'p.name',
                      quantity: 'sa.quantity',
                    },
                    from: 's:shift_atom_coock_plan',
                    from_as: 'sacp',
                    joins: [
                      {
                        join: 's:shift_plan_vdp',
                        type: 'left',
                        as:   'spv',
                        on: {
                          $eq: ['sacp.vdp_plan_id', 'spv.id']
                        }
                      },
                      {
                        join: 's:shifts',
                        type: 'left',
                        as:   's',
                        on: {
                          $eq: ['spv.shift_id', 's.id']
                        }
                      },
                      {
                        join: 's:voc_bases',
                        type: 'left',
                        as:   'vb',
                        on: {
                          $eq: ['sacp.base_id	', 'vb.id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['sacp.id']}
                    ],
                    where: {
                      $eq: [`sacp.shift_id`, {$: documentId}]
                    }
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
        });
    }
  }

export const mutations: MutationTree<ShiftAtomCoockPlanState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_FROM_DATA(state, {index, field, newValue}) {
    console.log('------>', index, field, newValue)
    const _idx = state.relatedPlansList.indexOf(index)
    state.relatedPlansList[_idx][field] = newValue;
  }

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftAtomCoockPlanState, RootState> = {
  totals : (state: ShiftAtomCoockPlanState) => {
    return {
      sum: state.relatedPlansList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
};

export const STORE_KEY = '$_shift_atom_plan_coock_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
